import * as React from 'react'
import { IAudioConfig } from 'store/LevelStore'
import styles from './index.scss'

export interface IPlayIcon {
  isPlay: boolean
  toggleAudioVoice?: (config: IAudioConfig) => void
}

const PlayIcon = ({ isPlay, toggleAudioVoice }) => {
  return (
    <i
      className={`play-icon ${styles.base} ${
        isPlay ? styles.play : styles.mute
      }`}
      onClick={toggleAudioVoice}
    />
  )
}

export default PlayIcon
